import styled, { device, themeGet, css } from "../../../styled";
import { Col } from "../../Common/Grid";
import { ModalBody, ModalHeader } from "../../Common/Modal";

export const StyledHeader = styled(({ backgroundColor, ...rest }) => (
  <ModalHeader {...rest} />
))`
  background-color: ${(props) => props.backgroundColor};
  padding: 10px;
  color: #fff;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  .nav-link {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const StyledTitle = styled.h6`
  margin-bottom: 0;
  font-weight: 400;
  position: relative;
  top: 1px;
  color: #fff;
`;

export const StyledBody = styled(({ ...rest }) => <ModalBody {...rest} />)`
  transition: all 0.3s;
  ${device.large} {
    padding: 20px;
  }
  .form-control {
    &:hover,
    &:focus {
      outline: none;
      border: none;
      box-shadow: none;
    }
  }
  ${(props) =>
    props.theme.name === "dark" &&
    css`
      border-width: 0;
      background-color: ${themeGet("colors.darkdarken3")};
      box-shadow: none;
      color: ${themeGet("colors.gray500")};
      .form-control {
        background-color: transparent;
        color: ${themeGet("colors.gray300")};
        &:placeholder {
          color: ${themeGet("colors.gray700")};
        }
      }
    `}
`;

export const StyledWrap = styled.div`
  background-color: #fff;
  margin-top: 15px;
  .ql {
    &-container {
      border-bottom-right-radius: 0.25rem;
      border-bottom-left-radius: 0.25rem;
      border-color: ${themeGet("colors.border")} !important;
      height: 80px;
      ${device.small} {
        height: 150px;
      }
    }
    &-editor {
      padding: 20px;
      color: ${themeGet("colors.text")};
    }
  }
  ${(props) =>
    props.theme.name === "dark" &&
    css`
      background-color: transparent;
      .ql-editor {
        color: ${themeGet("colors.gray500")};
        &.ql-blank {
          &:before {
            color: ${themeGet("colors.gray500")};
            font-style: normal;
            font-size: 18px;
          }
        }
      }
      .ql-snow.ql-toolbar button {
        .ql-stroke {
          stroke: ${themeGet("colors.gray700")};
        }

        &:hover,
        &:focus {
          background-color: ${themeGet("colors.gray900")};
          .ql-stroke {
            stroke: #fff;
          }
        }
      }
    `}
`;

export const StyledToolbarWrap = styled.div`
  margin-top: 25px;
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
`;

export const StyledToolbar = styled.div`
  padding: 0px !important;
  border: 0 !important;
  .ql {
    &-toolbar {
      border-top-left-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
    }
    &-formats {
      display: inline-flex;
    }
  }
`;

export const StyledBtnWrap = styled.div`
  margin-top: 15px;
  ${device.small} {
    margin-top: 0px;
  }
  button {
    font-size: 13px;
  }
`;

export const StyledDropzone = styled.div<{ hightlight: boolean }>`
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  border: 2px solid;
  border-radius: 4px;
  border-style: dashed;
  border-color: #919191;
  z-index: 200;
  display: ${(props) => (props.hightlight ? "block" : "none")};
  background-color: #d9d9d9ad;
`;

export const StyledFooterToolbar = styled(({ color, ...rest }) => (
  <Col {...rest} />
))`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  .sendBtt {
    background-color: ${(props) => props.color};
    border-color: ${(props) => props.color};
  }
`;

export const StyledEmptyStateContainer = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const StyledEmptyStateImageWrapper = styled.div`
  border: 2px dashed rgb(208, 214, 208);
  border-radius: 100%;
  width: 200px;
  height: 200px;
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const StyledEmptyStateImg = styled.img`
  width: 100px;
`;
